import Link from '@signplatform-ui/link';
import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledLink = styled(Link)`
  align-self: flex-start;
  margin-bottom: 8px;
`;
